<template>
  <div>
    <header id="home" class="relative flex items-end justify-center p-4 overflow-hidden" style="height: 33vw">
      <Ball1 class="absolute" style="left: 50%; bottom: -10vh; transform: translate(-50%, 0); height: 80vh" />
      <div class="absolute inset-0 bg-gradient-to-b from-transparent to-black"></div>
      <h1 class="relative flex flex-col font-extrabold text-white text-center">
        <img src="./assets/factory.png" alt="Factory" style="height: 8vw" />
        <small style="font-size: 4vw">DIABOTICAL&nbsp;&nbsp;INVITATIONAL</small>
      </h1>
    </header>

    <Navigation />

    <main class="overflow-x-hidden">
      <SectionResults />
      <!-- <SectionAnnouncement /> -->
      <!-- <SectionCountdown /> -->
      <SectionInfo />
      <SectionPrizepool />
      <SectionParticipants />
      <SectionRules />
      <SectionLocation />
      <SectionCovid />
    </main>

    <footer class="relative px-3 py-10 sm:px-4 sm:py-16 bg-gradient-to-br from-gray-700 to-gray-900 text-gray-100 text-center">
      <div class="container mx-auto space-y-10">
        <div class="space-y-4 inline-block">
          <b class="text-2xl" v-text="t('share')" />
          <div class="ya-share2 transform scale-150" data-services="vkontakte,facebook,twitter" data-counter="data-counter" data-size="m" />
        </div>
        <div class="text-gray-400">
          &copy;
          <a class="text-gray-400 hover:text-blue-400" href="https://vk.com/quakelife" target="_blank">Danmer</a>, 2020
        </div>
      </div>
    </footer>

    <SignupModal v-if="modals.signup" />
  </div>
</template>

<script>
  import { useI18n } from 'vue-i18n'
  import { modals } from './store.js'

  import SectionResults from './components/sections/Results.vue'
  // import SectionAnnouncement from './components/sections/Announcement.vue'
  // import SectionCountdown from './components/sections/Countdown.vue'
  import SectionInfo from './components/sections/Info.vue'
  import SectionPrizepool from './components/sections/Prizepool.vue'
  import SectionParticipants from './components/sections/Participants.vue'
  import SectionRules from './components/sections/Rules.vue'
  import SectionLocation from './components/sections/Location.vue'
  import SectionCovid from './components/sections/Covid.vue'

  import Ball1 from './components/Ball1.vue'
  import Navigation from './components/Navigation.vue'
  import SignupModal from './components/SignupModal.vue'

  export default {
    name: 'App',
    components: {
      SectionResults,
      // SectionAnnouncement,
      // SectionCountdown,
      SectionInfo,
      SectionPrizepool,
      SectionParticipants,
      SectionRules,
      SectionLocation,
      SectionCovid,
      Ball1,
      Navigation,
      SignupModal,
    },
    setup() {
      const { t } = useI18n({
        messages: {
          en: {
            share: 'Share',
          },
          ru: {
            share: 'Поделиться',
          },
        },
      })

      return { modals, t }
    },
  }
</script>

<style>
  @import 'tailwindcss/base';
  @import 'tailwindcss/components';
  @import 'tailwindcss/utilities';

  body {
    font-family: 'Open Sans', Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #fafafa;
    color: #333;
    border-color: #333;
    @apply text-xl;
  }

  header {
    background: url('./assets/pattern.png');
  }

  .h-16\/9 {
    position: relative;
    padding-bottom: 56.25%;
    width: 100%;
    height: 0;
  }
  .h-16\/9 > * {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .fa-rub,
  .fa-usd {
    font-size: 0.9em;
  }
</style>
